import { isMac } from './platform';

export const COMPACT_VIEW_QUERY = '(max-width: 767px)';

export function isCompactView(): boolean {
  return typeof window !== 'undefined' && window.matchMedia(COMPACT_VIEW_QUERY).matches;
}

export function formatKeyboardShortcut(shortcut: string): string {
  return shortcut
    .replace(/Alt/g, isMac() ? '⌥' : 'Alt')
    .replace(/Option/g, isMac() ? '⌥' : 'Option')
    .replace(/\s*\+\s*/g, '+');
}

if (typeof window !== 'undefined') {
  const guardKey = '__simplySendCompactShortcutGuard';
  const win = window as Window & { [guardKey]?: boolean };
  if (!win[guardKey]) {
    win[guardKey] = true;
    window.addEventListener(
      'keydown',
      (event: KeyboardEvent) => {
        if (!event.altKey || !isCompactView()) return;
        event.stopImmediatePropagation();
      },
      true,
    );
  }
}
